import isEmpty from 'lodash/isEmpty';
import {
  arrayOf,
  bool,
  func,
  number,
  object,
  oneOfType,
  string,
} from 'prop-types';
import React from 'react';

import getEventTargetValue from '../../utils/get-event-target-value';
import ActiveView from './ActiveView';
import InactiveView from './InactiveView';

class Association extends React.Component {
  state = {
    editing:
      !this.props.value || (this.props.isMulti && isEmpty(this.props.value)),
  };

  handleChange = (e, ...rest) => {
    const { isMulti, onChange } = this.props;
    if (!isMulti && getEventTargetValue(e.target)) {
      this.disableEdit();
    }
    onChange(e, ...rest);
  };

  enableEdit = () => {
    this.setState({ editing: true });
  };

  disableEdit = () => {
    this.setState({ editing: false });
  };

  render() {
    const { editing } = this.state;
    const {
      id,
      readOnly,
      searchParams,
      type,
      value,
      isMulti,
      onChange,
      disableInactiveView,
      additionalAddFormProps,
      ...rest
    } = this.props;

    const commonProps = {
      id,
      readOnly,
      type,
      value,
      isMulti,
    };

    if (
      disableInactiveView ||
      editing ||
      !value ||
      (isMulti && isEmpty(value))
    ) {
      return (
        <ActiveView
          {...commonProps}
          searchParams={searchParams}
          additionalAddFormProps={additionalAddFormProps}
          {...rest}
          onSelectBlur={this.disableEdit}
          onChange={this.handleChange}
        />
      );
    }

    return (
      <InactiveView
        {...commonProps}
        {...rest}
        onToggleActive={this.enableEdit}
      />
    );
  }
}

Association.propTypes = {
  id: string, // so that this can be a labelFor target
  name: string.isRequired,
  onChange: func,
  readOnly: bool,
  isMulti: bool,
  searchParams: object, // eslint-disable-line react/forbid-prop-types,
  type: string.isRequired,
  value: oneOfType([number, arrayOf(number.isRequired), string]),
  disableInactiveView: bool,
  additionalAddFormProps: object, // eslint-disable-line react/forbid-prop-types,
};

Association.defaultProps = {
  id: undefined,
  onChange: () => {},
  readOnly: false,
  searchParams: undefined,
  value: undefined,
  isMulti: false,
  disableInactiveView: false,
  additionalAddFormProps: {},
};

export default Association;
